// src/components/admin/Select.jsx
const Select = (props) => (
  <select
    {...props}
    className={`w-full rounded-2xl border border-gray-200 px-3 py-2 bg-white outline-none focus:ring-2 focus:ring-indigo-500 ${props.className || ""}`}
  />
);
export default Select;
